type CommunityIconProps = {
  size?: number;
  color?: string;
  className?: string;
  stroke?: number;
};

/** Community nav icon — vector path exported from Figma Design File_Diocesan (mapped to 24x24). */
export const CommunityIcon = ({ size = 24, color = 'currentColor', className, stroke = 1.5 }: CommunityIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M10 21V14.5C10 13.5717 9.63125 12.6815 8.97487 12.0251C8.3185 11.36875 7.42826 11 6.5 11M10 21H3V14.5C3 13.5717 3.36875 12.6815 4.02513 12.0251C4.6815 11.36875 5.57174 11 6.5 11M10 21H21V15C21 13.9391 20.5786 12.9217 19.8284 12.1716C19.0783 11.42143 18.0609 11 17 11H6.5M12 11V7M12 7V3H16L18 5L16 7H12ZM6 15H7"
      stroke={color}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
